import React, { useEffect, useState } from 'react';

const CartCard = ({title,rate,amount,imgUrl,count,onDeleteClick,onPlusClick,onMinusClick}) => {
  const [items, setItems] = useState([]);

  return (
<div className='cart-maincontainer'>
  <div className='cart-container'>
     <img className='cart-image' src={imgUrl}/>
<div className='cart-right'>
<h className="cart-head">{title}</h>
<p className='cart-rate'>Rate :<span>{rate}</span></p>
<p className='cart-amount'>${amount}</p>
</div>
</div>
<div className='cart-buton'>
  <div className='cart-svg'>
  <svg onClick={()=>onMinusClick()} className="red"stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path></svg>
<span>{count}</span>
<svg onClick={()=>onPlusClick()} className="green" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path></svg>
</div>
<svg onClick={()=>onDeleteClick()} className='red' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>
</div>
</div>
    
  );
};

export default CartCard;